// Address concatenation helpers for printable / display formats.

import { CompanyInfo } from '../models/company';
import { Customer } from '../models/accounting';

export function concatenateCompanyStreetAddress(address: CompanyInfo): string {
  let street_address: string = '';
  street_address = `${address.address} ${address.address2}`;
  return street_address;
}

export function concatenateCompanyCityStateAddress(
  address: CompanyInfo,
): string {
  let city_state_address: string = '';
  city_state_address = `${address.city} ${address.state} ${address.zip_code}`;
  return city_state_address;
}

export function concatenateCustomerStreetAddress(customer: Customer): string {
  let street_address: string = '';
  if (customer.address.street2) {
    street_address = `${customer.address.street} ${customer.address.street2}`;
  } else {
    street_address = `${customer.address.street}`;
  }
  return street_address;
}

export function concatenateCustomerCityStateAddress(
  customer: Customer,
): string {
  let city_state_address: string = '';
  city_state_address = `${customer.address.city} ${customer.address.state} ${customer.address.zip_code}`;
  return city_state_address;
}
